/**
 * TanStack Query hooks for `creative-hosting-inside-campaign`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	creativeHostingInsideCampaignQueryKeys,
	type CreateCreativeHostingInsideCampaignBody,
	type ListCreativeHostingInsideCampaignResponse,
	type CreativeHostingInsideCampaignRow,
} from "./api";

export function useCreativeHostingInsideCampaignList(): UseQueryResult<ListCreativeHostingInsideCampaignResponse, Error> {
	return useQuery({
		queryKey: creativeHostingInsideCampaignQueryKeys.list(),
		queryFn: list,
	});
}

export function useCreativeHostingInsideCampaignCreate(): UseMutationResult<CreativeHostingInsideCampaignRow, Error, CreateCreativeHostingInsideCampaignBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeHostingInsideCampaignQueryKeys.all });
		},
	});
}

export function useCreativeHostingInsideCampaignDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeHostingInsideCampaignQueryKeys.all });
		},
	});
}
